// INFO: lefover file for editor sdk provider. Left in case we need it again.....
import { desktopApi, isDesktop } from '@carboncopyco/mimesis-shared';
import { useMemo } from 'react';

export const useEditorCommunicationLayer = (id: number | undefined) => {
  const webCommunicationLayer = useMemo(
    () => ({
      sendMessage: (message) => window.postMessage(message),
      subscribe: (cb) => {
        window.addEventListener('message', cb);
        return () => window.removeEventListener('message', cb);
      },
    }),
    []
  );

  const desktopCommunicationLayer = useMemo(
    () => ({
      sendMessage: (message: any) => {
        desktopApi.editor.postMessage(message, id);
      },
      subscribe: (cb: (data: any) => void) => {
        desktopApi.editor.onMessage(cb, id);

        return () => {
          desktopApi.editor.removeEventListeners(id);
        };
      },
    }),
    [id]
  );

  if (isDesktop) {
    return desktopCommunicationLayer;
  }

  return webCommunicationLayer;
};
